"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manageFlashingDocumentTitle = exports.setFlashingTitleNotification = exports.formatTitleUnreadMessages = void 0;
const document_title_content_1 = __importDefault(require("./document-title.content"));
/**
 * Format a prospect document/tab title to include a notification
 * count in parentheses, formatted accordingly, where appropriate.
 *
 * @returns {string} The formatted title (does not set!)
 */
const formatTitleUnreadMessages = (unreadMessages, title) => {
  var _a;
  if (title === void 0) {
    title = (_a = document === null || document === void 0 ? void 0 : document.title) !== null && _a !== void 0 ? _a : document_title_content_1.default.DEFAULT_DOCUMENT_TITLE;
  }
  // Normalise title to remove any existing number counts
  title = title.replace(/^\(\d+\+?\)\s/, "");
  const hasDisplayableNumber = typeof unreadMessages === "number" && unreadMessages > 0;
  const hasMaxNumber = unreadMessages > 99;
  return hasDisplayableNumber ? `(${hasMaxNumber ? "99+" : unreadMessages}) ${title}` : title;
};
exports.formatTitleUnreadMessages = formatTitleUnreadMessages;
/**
 * Pre-configured `manageFlashingDocumentTitle` invocation for shared
 * implementation usage, i.e. between `launcher` and `client`.
 */
const setFlashingTitleNotification = (notificationCount, originalTabTitle) => {
  var _a;
  if (originalTabTitle === void 0) {
    originalTabTitle = (_a = document === null || document === void 0 ? void 0 : document.title) !== null && _a !== void 0 ? _a : document_title_content_1.default.DEFAULT_DOCUMENT_TITLE;
  }
  exports.manageFlashingDocumentTitle.start({
    on: (0, exports.formatTitleUnreadMessages)(notificationCount, document_title_content_1.default.NEW_MSG_TAB_TITLE),
    off: (0, exports.formatTitleUnreadMessages)(notificationCount, originalTabTitle),
    // Specify the origin title for when `stop()` is invoked
    reset: originalTabTitle
  });
};
exports.setFlashingTitleNotification = setFlashingTitleNotification;
/**
 * Set a "flashing" document/tab title by intermittently changing
 * the title between two values in a given interval duration.
 * Keeps accurate track of the original document/tab title for reliable
 * re-setting of title when stopping/clearing flashing status.
 *
 * Adapted from broken npm package `flashing-page-title-notification`.
 * Ref: https://github.com/curtistimson/flashing-page-title-notification/blob/develop/src/index.js
 */
exports.manageFlashingDocumentTitle = (() => {
  let existingTitle;
  let intervalRef;
  const isFlashing = () => intervalRef !== undefined;
  const stop = function () {
    if (!isFlashing()) return;
    window.clearInterval(intervalRef);
    intervalRef = undefined;
    document.title = existingTitle;
  };
  const flash = function (_ref) {
    let {
      on: flashOn,
      off: flashOff = document.title,
      reset: resetTitle = document.title,
      intervalDuration = 1000
    } = _ref;
    if (isFlashing()) stop();
    existingTitle = resetTitle;
    document.title = flashOn;
    intervalRef = window.setInterval(() => {
      const hasFlashTitle = document.title === flashOn;
      document.title = hasFlashTitle ? flashOff : flashOn;
    }, intervalDuration);
  };
  return {
    start: flash,
    stop
  };
})();